var scope_0 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f867df98cc26c50102abb05482949cf.js').default;
var scope_1 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/242949c50e461fcf420bb272b50960ef.js').default;
var scope_2 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/45e1577551af988b3b61a282e6553035.js').default;
var scope_3 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4bf6e68a8a5a668a9e1502e4207c85e1.js').default;
var scope_4 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6713973961a369c80ecc356be03fb600.js').default;
var scope_5 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/986b5c6f5f32300f10c0875eb0995185.js').default;
var scope_6 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bbcbdef38f6026ef3886ffd6676934a6.js').default;
var scope_7 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c3adea9b0eaa62df88a22e1d2f6e34e0.js').default;
var scope_8 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c7b3df9e3d1416160b7aa5c892793c50.js').default;
var scope_9 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d4956f66b7b4750508b901d2310b2660.js').default;
var scope_10 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e10495c65c8acacd6b1f785f5759a9c8.js').default;
var scope_11 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1c791850cfb027fe3395c7a535338e2.js').default;
var scope_12 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    